// Suggests matches for a bank transaction against known sources (Tools, Salaries).
// Matching is intentionally simple for phase 1:
//   - tool match: tool name appears in the transaction name (case-insensitive)
//   - salary match: team member name appears in the transaction name
// Returns the best suggestion or null. Amount/date checks are a bonus signal
// but not required — the user always confirms before status flips to matched.

const normalize = (s) => (s || "").toLowerCase().replace(/[^a-z0-9 ]/g, " ").replace(/\s+/g, " ").trim();

function nameOverlap(txnName, sourceName) {
  const t = normalize(txnName);
  const s = normalize(sourceName);
  if (!t || !s) return 0;
  if (t.includes(s)) return s.length;
  // Try matching first word of source (e.g. "Smartlead Premium" → "smartlead")
  const firstWord = s.split(" ")[0];
  if (firstWord.length >= 4 && t.includes(firstWord)) return firstWord.length;
  return 0;
}

export function suggestMatch(transaction, { tools = [], team = [] } = {}) {
  let best = null;
  let bestScore = 0;

  for (const tool of tools) {
    const score = nameOverlap(transaction.name, tool.name);
    if (score > bestScore) {
      bestScore = score;
      best = { sourceType: "tool", sourceId: tool.id, sourceName: tool.name, score };
    }
  }
  for (const member of team) {
    const score = nameOverlap(transaction.name, member.name);
    if (score > bestScore) {
      bestScore = score;
      best = { sourceType: "salary", sourceId: member.id, sourceName: member.name, score };
    }
  }

  // Require at least 4 chars of overlap to call it a suggestion
  return bestScore >= 4 ? best : null;
}

export const STATUS_FLAGGED = "flagged";
export const STATUS_MATCHED = "matched";